import { render, staticRenderFns } from "./longSentence.vue?vue&type=template&id=5a3d88a9&scoped=true&"
import script from "./longSentence.vue?vue&type=script&lang=js&"
export * from "./longSentence.vue?vue&type=script&lang=js&"
import style0 from "./longSentence.vue?vue&type=style&index=0&id=5a3d88a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d88a9",
  null
  
)

export default component.exports